module.exports = __webpack_public_path__ + "img/dialog-warning.807e9972.svg";